import { apiConfig } from "core-lib/config/config";
import { getMethod } from "core-lib/utils/apiV2";

export async function getProfile() {
  const { response, error }: any = await getMethod({
    endPoint: `${apiConfig("user")}/user/profile/`,
  });
  if (response) {
    return { response: response.user };
  }
  if (error) return { error };
}
